import { useLocation } from 'react-router-dom'
import { isProductAppPath } from '../../constants/productAppRoutes'

/**
 * Renders children only on product-app routes (dashboard, calendar, agenda, etc.).
 * Use for onboarding modals, feature overview video widgets, or any subtree that must
 * never mount on corporate/marketing pages (/, /pricing, /documentation, …).
 */
export default function ProductAppVideoBoundary({ children }) {
  const { pathname } = useLocation()
  if (!isProductAppPath(pathname)) return null
  return children
}
